 const enGB = {
        "letterA":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterA.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#201923",
                "Upper": "A",
                "images":
                    [
                        // {
                        //     "width": "110",
                        //     "height": "50",
                        //     "spriteSheeet": "images/transportation.svg",
                        //     "backgroundPositionX": "-50",
                        //     "backgroundPositionY": "-30",
                        //     "backgroundSize": "200%",
                        //     "type": "Airliner",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/transportation/Transportation_008_Airliner.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     },
                        //     "soundEffect":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/transportation/soundEffects/airplane-landing-6732.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "g12496",
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-174",
                            "centerBackgroundPositionX": "-96",
                            "backgroundPositionY": "-20",
                            "centerBackgroundPositionY": "-12",
                            "backgroundSize": "450%",
                            "type": "Aeroplane",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_003_Aeroplane.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/soundEffects/small-airplane-flyby-13849.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-215",
                            "centerBackgroundPositionX": "-188",
                            "backgroundPositionY": "-80",
                            "centerBackgroundPositionY": "-70",
                            "backgroundSize": "500%",
                            "type": "Apple",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_027_Apple.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-301",
                            "centerBackgroundPositionX": "-188",
                            "backgroundPositionY": "-190",
                            "centerBackgroundPositionY": "-120",
                            "backgroundSize": "500%",
                            "type": "Accordion",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/MusicalInstruments_001_Accordion.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/soundEffects/winbandoneon-96337.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterB":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterB.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#228c68",
                "Upper": "B",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-71",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "500%",
                            "type": "Beetroot",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_009_Beetroot.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "85",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-108",
                            "centerBackgroundPositionX": "-64",
                            "backgroundPositionY": "-208",
                            "centerBackgroundPositionY": "-121",
                            "backgroundSize": "750%",
                            "type": "Bed",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_011_Bed.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Blue",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_001_Blue.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes1.svg",
                        //     "backgroundPositionX": "-143",
                        //     "backgroundPositionY": "-16",
                        //     "backgroundSize": "400%",
                        //     "type": "Blue rectangle",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_004_BlueRectangle.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes2.svg",
                        //     "backgroundPositionX": "-131",
                        //     "backgroundPositionY": "-8",
                        //     "backgroundSize": "450%",
                        //     "type": "Blue cube",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_008_BlueCube.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes3.svg",
                        //     "backgroundPositionX": "-51",
                        //     "backgroundPositionY": "-14",
                        //     "backgroundSize": "400%",
                        //     "type": "Blue triangle",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_010_BlueTriangle.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "g14304",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-157",
                            "centerBackgroundPositionX": "-121",
                            "backgroundPositionY": "-173",
                            "centerBackgroundPositionY": "-134",
                            "backgroundSize": "600%",
                            "type": "Biplane",
                            "sound":
                            {
                                "html5": true,
                                "src": "audio/en-GB/Abbi/toys/Toys_012_Biplane.mp3",
                                "volume": 1,
                                "preload": true
                            },
                            "soundEffect":
                            {
                                "html5": true,
                                "src": "audio/en-GB/Abbi/toys/soundEffects/prop-plane-14513.mp3",
                                "volume": 1,
                                "preload": true
                            }
                        },
                        {
                            "elementId": "g12475",
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-93",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-10",
                            "backgroundSize": "550%",
                            "type": "Bicycle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_002_Bicycle.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/bicycle_bell-32072.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "Brown",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_009_Brown.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-178",
                            "centerBackgroundPositionX": "-178",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "Black",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_012_Black.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-73",
                            "centerBackgroundPositionX": "-41",
                            "backgroundPositionY": "-134",
                            "centerBackgroundPositionY": "-74",
                            "backgroundSize": "400%",
                            "type": "Bus",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_001_Bus.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/bus-arrival-71991.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "4",
                            "centerBackgroundPositionX": "4",
                            "backgroundPositionY": "-3",
                            "centerBackgroundPositionY": "-3",
                            "backgroundSize": "450%",
                            "type": "Broccoli",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_001_Broccoli.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-2",
                            "backgroundPositionY": "-70",
                            "centerBackgroundPositionY": "-70",
                            "backgroundSize": "550%",
                            "type": "Bok Choy",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_007_BokChoy.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "90",
                        //     "height": "50",
                        //     "spriteSheeet": "images/transportation.svg",
                        //     "backgroundPositionX": "-1",

                        //     "backgroundPositionY": "-175",

                        //     "backgroundSize": "500%",
                        //     "type": "Bicycle",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/transportation/Transportation_007_Bicycle.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     },
                        //     "soundEffect":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/transportation/soundEffects/bicycle_bell-32072.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-148",
                            "centerBackgroundPositionX": "-148",
                            "backgroundPositionY": "-64",
                            "centerBackgroundPositionY": "-64",
                            "backgroundSize": "700%",
                            "type": "Banana",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_026_Banana.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-4",
                            "backgroundPositionY": "-302",
                            "centerBackgroundPositionY": "-274",
                            "backgroundSize": "1000%",
                            "type": "Bison",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_029_Bison.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-119",
                            "centerBackgroundPositionX": "-119",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "300%",
                            "type": "Butter",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/dairyProducts/Dairy Products_004_Butter.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterC":
            {
                "colour": "#37294f",
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterC.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "Upper": "C",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-504",
                            "centerBackgroundPositionX": "-503",
                            "backgroundPositionY": "-264",
                            "centerBackgroundPositionY": "-264",
                            "backgroundSize": "1600%",
                            "type": "Chair",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_018_Chair.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-145",
                            "centerBackgroundPositionX": "-143",
                            "backgroundPositionY": "-119",
                            "centerBackgroundPositionY": "-119",
                            "backgroundSize": "950%",
                            "type": "Camel",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_014_Camel.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-102",
                            "centerBackgroundPositionX": "-102",
                            "backgroundPositionY": "-62",
                            "centerBackgroundPositionY": "-62",
                            "backgroundSize": "600%",
                            "type": "Cherries",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_025_Cherries.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-401",
                            "centerBackgroundPositionX": "-401",
                            "backgroundPositionY": "-167",
                            "centerBackgroundPositionY": "-167",
                            "backgroundSize": "1100%",
                            "type": "Chimpanzee",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_022_Chimpanzee.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/monkey-scream-6407.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-377",
                            "centerBackgroundPositionX": "-376",
                            "backgroundPositionY": "-468",
                            "centerBackgroundPositionY": "-469",
                            "backgroundSize": "1700%",
                            "type": "Chicken",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_036_Chicken.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/chicken-single-alarm-call-6056.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-4",
                            "centerBackgroundPositionX": "-4",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Crescent",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_009_Crescent.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-38",
                            "centerBackgroundPositionX": "-38",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "600%",
                            "type": "Carrot",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_002_Carrot.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-131",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "450%",
                            "type": "Cube",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_008_Cube.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-49",
                            "centerBackgroundPositionX": "-49",
                            "backgroundPositionY": "-10",
                            "centerBackgroundPositionY": "-10",
                            "backgroundSize": "450%",
                            "type": "Circle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_002_Circle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-48",
                            "centerBackgroundPositionX": "-39",
                            "backgroundPositionY": "-331",
                            "centerBackgroundPositionY": "-275",
                            "backgroundSize": "850%",
                            "type": "Cow",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_032_Cow.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/079276_cow-86620.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-250",
                            "centerBackgroundPositionX": "-251",
                            "backgroundPositionY": "-453",
                            "centerBackgroundPositionY": "-452",
                            "backgroundSize": "1900%",
                            "type": "Cat",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_034_Cat.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/cat-meow-6226.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-649",
                            "centerBackgroundPositionX": "-500",
                            "backgroundPositionY": "-234",
                            "centerBackgroundPositionY": "-179",
                            "backgroundSize": "1100%",
                            "type": "Crab",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_024_Crab.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-141",
                            "centerBackgroundPositionX": "-141",
                            "backgroundPositionY": "-58",
                            "centerBackgroundPositionY": "-58",
                            "backgroundSize": "550%",
                            "type": "Corn",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_011_Corn.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-223",
                            "centerBackgroundPositionX": "-223",
                            "backgroundPositionY": "-155",
                            "centerBackgroundPositionY": "-155",
                            "backgroundSize": "450%",
                            "type": "Coconut",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_017_Coconut.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-261",
                            "centerBackgroundPositionX": "-260",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "1000%",
                            "type": "Cockrel",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_003_Cockrel.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/cock-rooster-cockerel-scream-sound-100787.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-84",
                            "centerBackgroundPositionX": "-33",
                            "backgroundPositionY": "-241",
                            "centerBackgroundPositionY": "-223",
                            "backgroundSize": "250%",
                            "type": "Cruise ship",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_018_CruiseShip.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/boat-horn-6204.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-236",
                            "centerBackgroundPositionX": "-215",
                            "backgroundPositionY": "-330",
                            "centerBackgroundPositionY": "-299",
                            "backgroundSize": "1250%",
                            "type": "Chameleon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_027_Chameleon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-189",
                            "centerBackgroundPositionX": "-189",
                            "backgroundPositionY": "-416",
                            "centerBackgroundPositionY": "-416",
                            "backgroundSize": "1100%",
                            "type": "Comb",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_003_Comb.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-580",
                            "centerBackgroundPositionX": "-580",
                            "backgroundPositionY": "-582",
                            "centerBackgroundPositionY": "-582",
                            "backgroundSize": "1300%",
                            "type": "Clock",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_004_Clock.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/soundEffects/tic-tac-27828.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-297",
                            "centerBackgroundPositionX": "-212",
                            "backgroundPositionY": "-263",
                            "centerBackgroundPositionY": "-188",
                            "backgroundSize": "925%",
                            "type": "Cheetah",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_021_Cheetah.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-312",
                            "centerBackgroundPositionX": "-312",
                            "backgroundPositionY": "-37",
                            "centerBackgroundPositionY": "-37",
                            "backgroundSize": "950%",
                            "type": "Cymbals",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/MusicalInstruments_002_Cymbals.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/soundEffects/electribe-cymbals-slice-19-c6-85173.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "85",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-750",
                            "centerBackgroundPositionX": "-940",
                            "backgroundPositionY": "-286",
                            "centerBackgroundPositionY": "-169",
                            "backgroundSize": "1000%",
                            "type": "Coat hanger",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_015_CoatHanger.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-36",
                            "centerBackgroundPositionX": "-36",
                            "backgroundPositionY": "-49",
                            "centerBackgroundPositionY": "-49",
                            "backgroundSize": "650%",
                            "type": "Chilli Pepper",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_008_ChilliPepper.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "g13916",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-59",
                            "centerBackgroundPositionX": "-54",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-63",
                            "backgroundSize": "550%",
                            "type": "Car",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_007_Car.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/soundEffects/horn-hooter-94444.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-70",
                            "centerBackgroundPositionX": "-70",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "600%",
                            "type": "Cucumber",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_003_Cucumber.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-62",
                            "centerBackgroundPositionX": "-62",
                            "backgroundPositionY": "-65",
                            "centerBackgroundPositionY": "-65",
                            "backgroundSize": "325%",
                            "type": "Cheese",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/dairyProducts/Dairy Products_001_Cheese.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/buildings.svg",
                            "backgroundPositionX": "-114",
                            "centerBackgroundPositionX": "-104",
                            "backgroundPositionY": "-111",
                            "centerBackgroundPositionY": "-101",
                            "backgroundSize": "500%",
                            "type": "Cottage",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/buildings/Buildings_001_Cottage.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterD":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterD.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#ffcba5",
                "Upper": "D",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-145",
                            "centerBackgroundPositionX": "-144",
                            "backgroundPositionY": "-451",
                            "centerBackgroundPositionY": "-451",
                            "backgroundSize": "1500%",
                            "type": "Dog",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_033_Dog.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/barking-3-47779.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-272",
                            "centerBackgroundPositionX": "-272",
                            "backgroundPositionY": "-382",
                            "centerBackgroundPositionY": "-382",
                            "backgroundSize": "1250%",
                            "type": "Donkey",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_039_Donkey.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/jumento-101690.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/nouma.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Dope",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/Random_001_Dope.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/soundEffects/stupid-person-giggle-100494.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-50",
                            "centerBackgroundPositionX": "-50",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "450%",
                            "type": "Diamond",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_006_Diamond.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-168",
                            "centerBackgroundPositionX": "-168",
                            "backgroundPositionY": "-94",
                            "centerBackgroundPositionY": "-95",
                            "backgroundSize": "850%",
                            "type": "Deer",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_015_Deer.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "g14222",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-13",
                            "centerBackgroundPositionX": "-11",
                            "backgroundPositionY": "-155",
                            "centerBackgroundPositionY": "-141",
                            "backgroundSize": "650%",
                            "type": "Digger",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_011_Digger.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-142",
                            "centerBackgroundPositionX": "-142",
                            "backgroundPositionY": "-2",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "550%",
                            "type": "Dragon fruit",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_021_DragonFruit.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-67",
                            "centerBackgroundPositionX": "-56",
                            "backgroundPositionY": "-165",
                            "centerBackgroundPositionY": "-137",
                            "backgroundSize": "450%",
                            "type": "Double dekker bus",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_002_DoubleDekkerBus.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "57",
                            "height": "50",
                            "spriteSheeet": "images/random/dabel.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Devil",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/Random_002_Devil.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/soundEffects/evil-shreik-45560.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterE":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterE.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#ffc413",
                "Upper": "E",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-152",
                            "centerBackgroundPositionY": "-170",
                            "backgroundSize": "213%",
                            "type": "Eight",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_009_8.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "100",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-187",
                            "centerBackgroundPositionX": "-94",
                            "backgroundPositionY": "-286",
                            "centerBackgroundPositionY": "-144",
                            "backgroundSize": "325%",
                            "type": "Eye",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/bodyParts/Body Parts_002_Eye.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-205",
                            "centerBackgroundPositionX": "-205",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "800%",
                            "type": "Eggplant",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_006_Eggplant.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-120",
                            "centerBackgroundPositionX": "-120",
                            "backgroundPositionY": "-141",
                            "centerBackgroundPositionY": "-141",
                            "backgroundSize": "1100%",
                            "type": "Elephant",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_013_Elephant.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/elephant-trumpets-growls-6047.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes4.svg",
                        //     "backgroundPositionX": "-9",
                        //     "backgroundPositionY": "-14",
                        //     "backgroundSize": "400%",
                        //     "type": "Ellipse",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/shapes/Shapes_012_Ellipse.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-90",
                            "centerBackgroundPositionX": "-90",
                            "backgroundPositionY": "-46",
                            "centerBackgroundPositionY": "-46",
                            "backgroundSize": "400%",
                            "type": "Ear",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/bodyParts/Body Parts_005_Ear.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterF":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterF.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#f07cab",
                "Upper": "F",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-145",
                            "centerBackgroundPositionX": "-145",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "1300%",
                            "type": "Frog",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_002_Frog.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/frog_quak-81741.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-530",
                            "centerBackgroundPositionX": "-522",
                            "backgroundPositionY": "-180",
                            "centerBackgroundPositionY": "-127",
                            "backgroundSize": "1150%",
                            "type": "Fish",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_016_Fish.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "213%",
                            "type": "Five",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_006_5.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-103",
                            "centerBackgroundPositionX": "-103",
                            "backgroundPositionY": "-446",
                            "centerBackgroundPositionY": "-446",
                            "backgroundSize": "1700%",
                            "type": "Fridge",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_008_Fridge.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-201",
                            "centerBackgroundPositionY": "-190",
                            "backgroundSize": "213%",
                            "type": "Four",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_005_4.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "110",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-172",
                            "centerBackgroundPositionX": "-78",
                            "backgroundPositionY": "-49",
                            "centerBackgroundPositionY": "-22",
                            "backgroundSize": "600%",
                            "type": "Flute",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/MusicalInstruments_003_Flute.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/soundEffects/flautatravessera-46420.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-261",
                            "centerBackgroundPositionX": "-261",
                            "backgroundPositionY": "-193",
                            "centerBackgroundPositionY": "-193",
                            "backgroundSize": "1200%",
                            "type": "Fan",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_016_Fan.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterG":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterG.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#5d4c86",
                "Upper": "G",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "25",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-63",
                            "centerBackgroundPositionX": "-63",
                            "backgroundPositionY": "-90",
                            "centerBackgroundPositionY": "-90",
                            "backgroundSize": "1500%",
                            "type": "Giraffe",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_012_Giraffe.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-66",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "Grey",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_010_Grey.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-117",
                            "centerBackgroundPositionX": "-117",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "750%",
                            "type": "Green peas",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_010_GreenPeas.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-62",
                            "centerBackgroundPositionY": "-62",
                            "backgroundSize": "600%",
                            "type": "Grapes",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_023_Grapes.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-116",
                            "centerBackgroundPositionX": "-116",
                            "backgroundPositionY": "-158",
                            "centerBackgroundPositionY": "-158",
                            "backgroundSize": "600%",
                            "type": "Garlic",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_015_Garlic.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-189",
                            "centerBackgroundPositionX": "-189",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "450%",
                            "type": "Guava",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_022_Guava.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Green",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_005_Green.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes2.svg",
                        //     "backgroundPositionX": "-8",

                        //     "backgroundPositionY": "-14",

                        //     "backgroundSize": "400%",
                        //     "type": "Green trapezoid",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_005_GreenTrapezoid.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes3.svg",
                        //     "backgroundPositionX": "-140",
                        //     "backgroundPositionY": "-15",
                        //     "backgroundSize": "400%",
                        //     "type": "Green parallelogram",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_012_GreenParallelogram.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes4.svg",
                        //     "backgroundPositionX": "-52",
                        //     "backgroundPositionY": "-11",

                        //     "backgroundSize": "460%",
                        //     "type": "Green pentagon",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_014_GreenPentagon.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-196",
                            "centerBackgroundPositionX": "-196",
                            "backgroundPositionY": "-66",
                            "centerBackgroundPositionY": "-66",
                            "backgroundSize": "600%",
                            "type": "Ginger",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_012_Ginger.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-60",
                            "centerBackgroundPositionX": "-60",
                            "backgroundPositionY": "-150",
                            "centerBackgroundPositionY": "-150",
                            "backgroundSize": "575%",
                            "type": "Green Pepper",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_014_GreenPepper.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-139",
                            "centerBackgroundPositionX": "-139",
                            "backgroundPositionY": "-3",
                            "centerBackgroundPositionY": "-3",
                            "backgroundSize": "500%",
                            "type": "Gramophone",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/MusicalInstruments_004_Gramophone.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterH":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterH.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#632819",
                "Upper": "H",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-78",
                            "centerBackgroundPositionX": "-78",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "400%",
                            "type": "Hexagon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_007_Hexagon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-126",
                            "centerBackgroundPositionX": "-70",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "425%",
                            "type": "Helicopter",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_017_Helicopter.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/helicopter-flyby-8114.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "g14148",
                        //     "width": "55",
                        //     "height": "50",
                        //     "spriteSheeet": "images/toys.svg",
                        //     "backgroundPositionX": "-239",
                        //     "centerBackgroundPositionX": "-216",
                        //     "backgroundPositionY": "-68",
                        //     "centerBackgroundPositionY": "-63",
                        //     "backgroundSize": "550%",
                        //     "type": "Helicopter",
                        //     "sound":
                        //         {
                        //             "html5": true,
                        //             "src": "audio/en-GB/Abbi/toys/Toys_010_Helicopter.mp3",
                        //             "volume": 1,
                        //             "preload": true
                        //         },
                        //     "soundEffect":
                        //         {
                        //             "html5": true,
                        //             "src": "audio/en-GB/Abbi/transportation/soundEffects/helicopter-flyby-8114.mp3",
                        //             "volume": 1,
                        //             "preload": true
                        //         }
                        // },
                        {
                            "elementId": "",
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-243",
                            "centerBackgroundPositionX": "-173",
                            "backgroundPositionY": "-186",
                            "centerBackgroundPositionY": "-132",
                            "backgroundSize": "450%",
                            "type": "High-speed train",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_013_HighspeedTrain.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/031973_trnelec_passby-regional-french-train-ter-at-high-speed-close-up_pierre-marie-blind_schoeps-mswav-62458.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-38",
                            "centerBackgroundPositionX": "-38",
                            "backgroundPositionY": "-39",
                            "centerBackgroundPositionY": "-39",
                            "backgroundSize": "250%",
                            "type": "Hand",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/bodyParts/Body Parts_004_Hand.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-137",
                            "centerBackgroundPositionX": "-137",
                            "backgroundPositionY": "-248",
                            "centerBackgroundPositionY": "-248",
                            "backgroundSize": "1300%",
                            "type": "Horse",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_026_Horse.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/horse-neigh-shortened-84724.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-171",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-268",
                            "centerBackgroundPositionY": "-206",
                            "backgroundSize": "1050%",
                            "type": "Hippopotamus",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_020_Hippopotamus.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "1",
                            "centerBackgroundPositionX": "1",
                            "backgroundPositionY": "-33",
                            "centerBackgroundPositionY": "-33",
                            "backgroundSize": "550%",
                            "type": "Hot-air balloon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_005_HotairBaloon.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/hotairbaloontorch-60586.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-95",
                            "centerBackgroundPositionX": "-95",
                            "backgroundPositionY": "-12",
                            "centerBackgroundPositionY": "-12",
                            "backgroundSize": "425%",
                            "type": "Heart",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_014_Heart.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterI":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterI.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#277da7",
                "Upper": "I",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/buildings.svg",
                            "backgroundPositionX": "-34",
                            "centerBackgroundPositionX": "-24",
                            "backgroundPositionY": "-127",
                            "centerBackgroundPositionY": "-139",
                            "backgroundSize": "425%",
                            "type": "Igloo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/buildings/Buildings_002_Igloo.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterJ":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterJ.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#e68f66",
                "Upper": "J",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-500",
                            "centerBackgroundPositionX": "-500",
                            "backgroundPositionY": "-284",
                            "centerBackgroundPositionY": "-284",
                            "backgroundSize": "1600%",
                            "type": "Jellyfish",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_028_Jellyfish.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterK":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterK.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#f47a22",
                "Upper": "K",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "-111",
                            "centerBackgroundPositionY": "-113",
                            "backgroundSize": "1000%",
                            "type": "Kangaroo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_010_Kangaroo.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-13",
                            "centerBackgroundPositionY": "-13",
                            "backgroundSize": "1800%",
                            "type": "Koala",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_001_Koala.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-305",
                            "centerBackgroundPositionX": "-305",
                            "backgroundPositionY": "-11",
                            "centerBackgroundPositionY": "-11",
                            "backgroundSize": "1000%",
                            "type": "Kettle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_005_Kettle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-25",
                            "centerBackgroundPositionX": "-24",
                            "backgroundPositionY": "-95",
                            "centerBackgroundPositionY": "-86",
                            "backgroundSize": "1000%",
                            "type": "Knife",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_009_Knife.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterL":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterL.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#d30b94",
                "Upper": "L",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-75",
                            "centerBackgroundPositionX": "-75",
                            "backgroundPositionY": "-122",
                            "centerBackgroundPositionY": "-122",
                            "backgroundSize": "700%",
                            "type": "Lemon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_029_Lemon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-1",
                            "centerBackgroundPositionX": "-1",
                            "backgroundPositionY": "-272",
                            "centerBackgroundPositionY": "-272",
                            "backgroundSize": "1200%",
                            "type": "Lion",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_025_Lion.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/roar-47757.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-229",
                            "centerBackgroundPositionX": "-229",
                            "backgroundPositionY": "-209",
                            "centerBackgroundPositionY": "-209",
                            "backgroundSize": "1600%",
                            "type": "Lamp",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_007_Lamp.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "g12430",
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-13",
                            "centerBackgroundPositionX": "-8",
                            "backgroundPositionY": "-17",
                            "centerBackgroundPositionY": "-10",
                            "backgroundSize": "500%",
                            "type": "Lorry",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_001_Lorry.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-171",
                            "centerBackgroundPositionX": "-171",
                            "backgroundPositionY": "-232",
                            "centerBackgroundPositionY": "-232",
                            "backgroundSize": "1100%",
                            "type": "Lighter",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_017_Lighter.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "110",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-352",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-106",
                            "centerBackgroundPositionY": "-49",
                            "backgroundSize": "425%",
                            "type": "Limousine",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_009_Limousine.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterM":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterM.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#fcff5d",
                "Upper": "M",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-159",
                            "centerBackgroundPositionX": "-159",
                            "backgroundPositionY": "-2",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "650%",
                            "type": "Mushroom",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_005_Mushroom.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-95",
                            "centerBackgroundPositionX": "-95",
                            "backgroundPositionY": "-2",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "590%",
                            "type": "Mango",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_020_Mango.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "75",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-200",
                            "centerBackgroundPositionX": "-200",
                            "backgroundPositionY": "-146",
                            "centerBackgroundPositionY": "-146",
                            "backgroundSize": "375%",
                            "type": "Mangosteen",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_031_Mangosteen.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-33",
                            "centerBackgroundPositionX": "-28",
                            "backgroundPositionY": "-145",
                            "centerBackgroundPositionY": "-121",
                            "backgroundSize": "300%",
                            "type": "Mouth",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/bodyParts/Body Parts_003_Mouth.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-121",
                            "centerBackgroundPositionX": "-121",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "425%",
                            "type": "Milk",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/dairyProducts/Dairy Products_003_Milk.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterN":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterN.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#235b54",
                "Upper": "N",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-201",
                            "centerBackgroundPositionY": "-190",
                            "backgroundSize": "213%",
                            "type": "Nine",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_010_9.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-6",
                            "backgroundPositionY": "-47",
                            "centerBackgroundPositionY": "-47",
                            "backgroundSize": "350%",
                            "type": "Nose",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/bodyParts/Body Parts_001_Nose.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterO":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterO.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#3750db",
                "Upper": "O",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-54",
                            "centerBackgroundPositionY": "-22",
                            "backgroundSize": "213%",
                            "type": "One",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_002_1.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-384",
                            "centerBackgroundPositionX": "-350",
                            "backgroundPositionY": "-412",
                            "centerBackgroundPositionY": "-375",
                            "backgroundSize": "1100%",
                            "type": "Octopus",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_037_Octopus.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-122",
                            "centerBackgroundPositionX": "-122",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Orange",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_007_Orange.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes4.svg",
                        //     "backgroundPositionX": "-131",

                        //     "backgroundPositionY": "-9",
                        //     "backgroundSize": "450%",
                        //     "type": "Orange star",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_016_OrangeStar.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes3.svg",
                        //     "backgroundPositionX": "-88",
                        //     "backgroundPositionY": "-9",

                        //     "backgroundSize": "450%",
                        //     "type": "Oval",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/shapes/Shapes_010_Oval.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-2",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "450%",
                            "type": "Orange",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_018_Orange.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Oval",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_010_Oval.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterP":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterP.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#c56133",
                "Upper": "P",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-43",
                            "centerBackgroundPositionX": "-44",
                            "backgroundPositionY": "-75",
                            "centerBackgroundPositionY": "-74",
                            "backgroundSize": "1300%",
                            "type": "Penguin",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_004_Penguin.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-66",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Pink",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_002_Pink.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes1.svg",
                        //     "backgroundPositionX": "-86",
                        //     "backgroundPositionY": "-8",

                        //     "backgroundSize": "440%",
                        //     "type": "Pink triangle",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_003_PinkTriangle.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes2.svg",
                        //     "backgroundPositionX": "-50",
                        //     "backgroundPositionY": "-8",

                        //     "backgroundSize": "450%",
                        //     "type": "Pink diamond",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_006_PinkDiamond.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes3.svg",
                        //     "backgroundPositionX": "-88",
                        //     "backgroundPositionY": "-9",

                        //     "backgroundSize": "450%",
                        //     "type": "Pink oval",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_011_PinkOval.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "45",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes4.svg",
                        //     "backgroundPositionX": "-95",
                        //     "backgroundPositionY": "-12",
                        //     "backgroundSize": "425%",
                        //     "type": "Pink heart",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_015_PinkHeart.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "g13945",
                        //     "width": "55",
                        //     "height": "50",
                        //     "spriteSheeet": "images/toys.svg",
                        //     "backgroundPositionX": "-113",
                        //     "centerBackgroundPositionX": "-103",
                        //     "backgroundPositionY": "-67",
                        //     "centerBackgroundPositionY": "-61",
                        //     "backgroundSize": "550%",
                        //     "type": "Propeller plane",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/toys/Toys_008_PropellerPlane.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     },
                        //     "soundEffect":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/toys/soundEffects/prop-plane-14513.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-23",
                            "centerBackgroundPositionX": "-15",
                            "backgroundPositionY": "-21",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "800%",
                            "type": "Pot",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_002_Pot.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-124",
                            "centerBackgroundPositionX": "-124",
                            "backgroundPositionY": "-124",
                            "centerBackgroundPositionY": "-124",
                            "backgroundSize": "550%",
                            "type": "Pear",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_030_Pear.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-337",
                            "centerBackgroundPositionX": "-259",
                            "backgroundPositionY": "-483",
                            "centerBackgroundPositionY": "-372",
                            "backgroundSize": "1300%",
                            "type": "Porcupine",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_030_Porcupine.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-180",
                            "centerBackgroundPositionX": "-99",
                            "backgroundPositionY": "-224",
                            "centerBackgroundPositionY": "-124",
                            "backgroundSize": "400%",
                            "type": "Pick-up",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_003_PickUp.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-180",
                            "centerBackgroundPositionX": "-180",
                            "backgroundPositionY": "-175",
                            "centerBackgroundPositionY": "-175",
                            "backgroundSize": "500%",
                            "type": "Pumpkin",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_016_Pumpkin.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-53",
                            "centerBackgroundPositionX": "-53",
                            "backgroundPositionY": "-62",
                            "centerBackgroundPositionY": "-62",
                            "backgroundSize": "600%",
                            "type": "Pineapple",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_024_Pineapple.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-100",
                            "centerBackgroundPositionX": "-100",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "500%",
                            "type": "Potato",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_004_Potato.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "g13857",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-6",
                            "backgroundPositionY": "-55",
                            "centerBackgroundPositionY": "-55",
                            "backgroundSize": "600%",
                            "type": "Pirate ship",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_006_PirateShip.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-101",
                            "centerBackgroundPositionX": "-101",
                            "backgroundPositionY": "-40",
                            "centerBackgroundPositionY": "-40",
                            "backgroundSize": "1200%",
                            "type": "Peacock",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_005_Peacock.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-163",
                            "centerBackgroundPositionX": "-163",
                            "backgroundPositionY": "-86",
                            "centerBackgroundPositionY": "-86",
                            "backgroundSize": "1100%",
                            "type": "Pelican",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_006_Pelican.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-61",
                            "centerBackgroundPositionX": "-61",
                            "backgroundPositionY": "-159",
                            "centerBackgroundPositionY": "-159",
                            "backgroundSize": "1400%",
                            "type": "Panda",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_011_Panda.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-1",
                            "centerBackgroundPositionX": "-1",
                            "backgroundPositionY": "-428",
                            "centerBackgroundPositionY": "-356",
                            "backgroundSize": "1100%",
                            "type": "Pig",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_031_Pig.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/pig-oink-47167.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-141",
                            "centerBackgroundPositionX": "-117",
                            "backgroundPositionY": "-553",
                            "centerBackgroundPositionY": "-461",
                            "backgroundSize": "1200%",
                            "type": "Pillow",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_012_Pillow.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-176",
                            "centerBackgroundPositionX": "-176",
                            "backgroundPositionY": "3",
                            "centerBackgroundPositionY": "3",
                            "backgroundSize": "600%",
                            "type": "Parachute",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_011_Parachute.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-52",
                            "centerBackgroundPositionX": "-52",
                            "backgroundPositionY": "-11",
                            "centerBackgroundPositionY": "-11",
                            "backgroundSize": "460%",
                            "type": "Pentagon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_013_Pentagon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_541832350_Tapka.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Paw",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/Random_004_Paw.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-140",
                            "centerBackgroundPositionX": "-140",
                            "backgroundPositionY": "-15",
                            "centerBackgroundPositionY": "-15",
                            "backgroundSize": "400%",
                            "type": "Parallelogram",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_011_Parallelogram.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterQ":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterQ.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#2f2aa0",
                "Upper": "Q",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_1617896356_Quasimodo.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Quasimodo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/Random_003_Quasimodo.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterR":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterR.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#632819",
                "Upper": "R",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-143",
                            "centerBackgroundPositionX": "-143",
                            "backgroundPositionY": "-16",
                            "centerBackgroundPositionY": "-16",
                            "backgroundSize": "400%",
                            "type": "Rectangle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_004_Rectangle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "4",
                            "centerBackgroundPositionX": "4",
                            "backgroundPositionY": "-240",
                            "centerBackgroundPositionY": "-184",
                            "backgroundSize": "1000%",
                            "type": "Rhinoceros",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_017_Rhinoceros.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-228",
                            "centerBackgroundPositionX": "-127",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "425%",
                            "type": "Race car",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_004_RaceCar.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/long-beach-indy-car-2014-04-13-20067.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes1.svg",
                        //     "backgroundPositionX": "-49",

                        //     "backgroundPositionY": "-10",
                        //     "backgroundSize": "450%",
                        //     "type": "Red circle",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_002_RedCircle.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-178",
                            "centerBackgroundPositionX": "-178",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Red",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_004_Red.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterS":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterS.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#7dfc00",
                "Upper": "S",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-177",
                            "centerBackgroundPositionX": "-111",
                            "backgroundPositionY": "-201",
                            "centerBackgroundPositionY": "-126",
                            "backgroundSize": "325%",
                            "type": "Sailing boat",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_012_Sailingboat.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/cannon-shot-6153.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "g14108",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-162",
                            "centerBackgroundPositionX": "-125",
                            "backgroundPositionY": "-65",
                            "centerBackgroundPositionY": "-51",
                            "backgroundSize": "450%",
                            "type": "Submarine",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_009_Submarine.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-214",
                            "centerBackgroundPositionX": "-214",
                            "backgroundPositionY": "-318",
                            "centerBackgroundPositionY": "-318",
                            "backgroundSize": "1200%",
                            "type": "Sheep",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_035_Sheep.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/sheeplings-80615.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-631",
                            "centerBackgroundPositionX": "-750",
                            "backgroundPositionY": "-565",
                            "centerBackgroundPositionY": "-658",
                            "backgroundSize": "800%",
                            "type": "Seal",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_040_Seal.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/sound-of-a-seal-14648.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-186",
                            "centerBackgroundPositionX": "-170",
                            "backgroundPositionY": "-95",
                            "centerBackgroundPositionY": "-87",
                            "backgroundSize": "1000%",
                            "type": "Spoon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_006_Spoon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-55",
                            "centerBackgroundPositionX": "-55",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "600%",
                            "type": "Strawberry",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_019_Strawberry.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-7",
                            "centerBackgroundPositionX": "-7",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Square",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_001_Square.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-131",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-9",
                            "centerBackgroundPositionY": "-9",
                            "backgroundSize": "450%",
                            "type": "Star",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_015_Star.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-5",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-264",
                            "centerBackgroundPositionY": "-166",
                            "backgroundSize": "400%",
                            "type": "Speedboat",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_014_Speedboat.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/boat-on-river-26388.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "g12544",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-229",
                            "centerBackgroundPositionX": "-229",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "700%",
                            "type": "Scooter",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_004_Scooter.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-18",
                            "centerBackgroundPositionX": "-19",
                            "backgroundPositionY": "-492",
                            "centerBackgroundPositionY": "-494",
                            "backgroundSize": "1400%",
                            "type": "Snail",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_038_Snail.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-54",
                            "centerBackgroundPositionY": "-22",
                            "backgroundSize": "213%",
                            "type": "Six",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_007_6.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "75",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-302",
                            "centerBackgroundPositionX": "-210",
                            "backgroundPositionY": "-65",
                            "centerBackgroundPositionY": "-41",
                            "backgroundSize": "675%",
                            "type": "Shark",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_009_Shark.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-103",
                            "centerBackgroundPositionY": "-149",
                            "backgroundSize": "213%",
                            "type": "Seven",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_008_7.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterT":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterT.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#29bdab",
                "Upper": "T",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "75",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-497",
                            "centerBackgroundPositionX": "-332",
                            "backgroundPositionY": "-242",
                            "centerBackgroundPositionY": "-161",
                            "backgroundSize": "950%",
                            "type": "Turtle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_023_Turtle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-454",
                            "centerBackgroundPositionX": "-454",
                            "backgroundPositionY": "-18",
                            "centerBackgroundPositionY": "-18",
                            "backgroundSize": "1200%",
                            "type": "Table",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_013_Table.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-3",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-144",
                            "centerBackgroundPositionY": "-144",
                            "backgroundSize": "500%",
                            "type": "Tomato",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_013_Tomato.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "g12686",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-289",
                            "centerBackgroundPositionX": "-241",
                            "backgroundPositionY": "-9",
                            "centerBackgroundPositionY": "-9",
                            "backgroundSize": "600%",
                            "type": "Train",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/Toys_005_Train.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/toys/soundEffects/train-railroad-traffic-sound-8002.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-257",
                            "centerBackgroundPositionX": "-184",
                            "backgroundPositionY": "-127",
                            "centerBackgroundPositionY": "-90",
                            "backgroundSize": "475%",
                            "type": "Truck",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_010_Truck.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/zur_pfx_truck_horns_different_ms-73563.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-103",
                            "centerBackgroundPositionY": "-149",
                            "backgroundSize": "213%",
                            "type": "Two",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_003_2.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-8",
                            "centerBackgroundPositionX": "-8",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Trapezium",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_005_Trapezium.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-178",
                            "centerBackgroundPositionX": "-178",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Turquoise",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_008_Turquoise.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-280",
                            "centerBackgroundPositionX": "-255",
                            "backgroundPositionY": "-77",
                            "centerBackgroundPositionY": "-70",
                            "backgroundSize": "1000%",
                            "type": "Toucan",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_008_Toucan.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-63",
                            "centerBackgroundPositionX": "-63",
                            "backgroundPositionY": "-242",
                            "centerBackgroundPositionY": "-242",
                            "backgroundSize": "1300%",
                            "type": "Tiger",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_018_Tiger.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/tiger-87706.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-152",
                            "centerBackgroundPositionY": "-170",
                            "backgroundSize": "213%",
                            "type": "Three",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_004_3.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-275",
                            "centerBackgroundPositionX": "-275",
                            "backgroundPositionY": "-87",
                            "centerBackgroundPositionY": "-87",
                            "backgroundSize": "900%",
                            "type": "Tambourine",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/MusicalInstruments_005_Tambourine.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/soundEffects/tambourine-2-bars-loop-90bpm-44-46139.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "110",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-152",
                            "centerBackgroundPositionX": "-69",
                            "backgroundPositionY": "-63",
                            "centerBackgroundPositionY": "-30",
                            "backgroundSize": "450%",
                            "type": "Trumpet",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/MusicalInstruments_006_Trumpet.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/soundEffects/trumpet-e4-14829.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-240",
                            "centerBackgroundPositionX": "-240",
                            "backgroundPositionY": "-440",
                            "centerBackgroundPositionY": "-441",
                            "backgroundSize": "1000%",
                            "type": "Television",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_014_Television.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/buildings.svg",
                            "backgroundPositionX": "-20",
                            "centerBackgroundPositionX": "-20",
                            "backgroundPositionY": "-12",
                            "centerBackgroundPositionY": "-12",
                            "backgroundSize": "450%",
                            "type": "Teepee",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/buildings/Buildings_003_Teepee.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "425%",
                            "type": "Taxi",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_015_Taxi.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-110",
                            "centerBackgroundPositionX": "-92",
                            "backgroundPositionY": "-81",
                            "centerBackgroundPositionY": "-73",
                            "backgroundSize": "375%",
                            "type": "Tram",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_016_Tram.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/soundEffects/tram_bell_ride_door-18009.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-86",
                            "centerBackgroundPositionX": "-86",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "440%",
                            "type": "Triangle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/shapes/Shapes_003_Triangle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes3.svg",
                        //     "backgroundPositionX": "-51",
                        //     "backgroundPositionY": "-14",
                        //     "backgroundSize": "400%",
                        //     "type": "Triangle",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/shapes/Shapes_003_Triangle.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_271533809_WC.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Toilet",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/Random_005_Toilet.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/soundEffects/toilet-flush-refilling-of-toilet-tank-29609.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterU":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterU.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#f22020",
                "Upper": "U",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-367",
                            "centerBackgroundPositionX": "-306",
                            "backgroundPositionY": "-456",
                            "centerBackgroundPositionY": "-380",
                            "backgroundSize": "1000%",
                            "type": "Umbrella",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_001_Umbrella.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/soundEffects/rain-underneath-umbrella-97410.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterV":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterV.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#96341c",
                "Upper": "V",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-242",
                            "centerBackgroundPositionX": "-242",
                            "backgroundPositionY": "-80",
                            "centerBackgroundPositionY": "-80",
                            "backgroundSize": "1150%",
                            "type": "Vulture",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_007_Vulture.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/soundEffects/vulture-88478.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-66",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Violet",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_006_Violet.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes4.svg",
                        //     "backgroundPositionX": "-9",
                        //     "backgroundPositionY": "-14",
                        //     "backgroundSize": "400%",
                        //     "type": "Violet ellipse",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_013_VioletEllipse.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // }
                    ]
            },
        "letterW":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterW.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#b732cc",
                "Upper": "W",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-3",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-109",
                            "centerBackgroundPositionY": "-109",
                            "backgroundSize": "325%",
                            "type": "Whipped cream",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/dairyProducts/Dairy Products_005_WhippedCream.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-183",
                            "centerBackgroundPositionX": "-141",
                            "backgroundPositionY": "-489",
                            "centerBackgroundPositionY": "-376",
                            "backgroundSize": "850%",
                            "type": "Window",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/homeObjects/Home Objects_010_Window.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-2",
                            "backgroundPositionY": "-113",
                            "centerBackgroundPositionY": "-113",
                            "backgroundSize": "350%",
                            "type": "Watermelon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/food/FruitsAndVegetables_028_Watermelon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-122",
                            "centerBackgroundPositionX": "-122",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "White",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_011_White.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterX":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterX.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#c3a5b4",
                "Upper": "X",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-254",
                            "centerBackgroundPositionX": "-196",
                            "backgroundPositionY": "-102",
                            "centerBackgroundPositionY": "-78",
                            "backgroundSize": "500%",
                            "type": "Xylophone",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/MusicalInstruments_007_Xylophone.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/musicalInstruments/soundEffects/xylophone-tones-105880.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterY":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterY.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#0ec434",
                "Upper": "Y",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-10",
                            "centerBackgroundPositionX": "-10",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "425%",
                            "type": "Yoghurt",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/dairyProducts/Dairy Products_002_Yoghurt.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "1",
                            "centerBackgroundPositionX": "1",
                            "backgroundPositionY": "-95",
                            "centerBackgroundPositionY": "-95",
                            "backgroundSize": "450%",
                            "type": "Yacht",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/transportation/Transportation_006_Yacht.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-122",
                            "centerBackgroundPositionX": "-122",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Yellow",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/colours/Colours_003_Yellow.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes1.svg",
                        //     "backgroundPositionX": "-7",

                        //     "backgroundPositionY": "-14",

                        //     "backgroundSize": "400%",
                        //     "type": "Yellow square",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_001_YellowSquare.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "40",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes2.svg",
                        //     "backgroundPositionX": "-78",
                        //     "backgroundPositionY": "-5",
                        //     "backgroundSize": "400%",
                        //     "type": "Yellow Hexagon",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_007_YellowHexagon.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        // {
                        //     "elementId": "w,
                        //     idth": "50",
                        //     "height": "50",
                        //     "spriteSheeet": "images/colourShapes3.svg",
                        //     "backgroundPositionX": "-4",
                        //     "backgroundPositionY": "-14",
                        //     "backgroundSize": "400%",
                        //     "type": "Yellow Crescent",
                        //     "sound":
                        //     {
                        //         "html5": true,
                        //         "src": "audio/en-GB/Abbi/colourShapes/ColourShapes_009_YellowCrescent.mp3",
                        //         "volume": 1,
                        //         "preload": true
                        //     }
                        // },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_1294860409_Yetti.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Yetti",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/Random_006_Yetti.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/random/soundEffects/monster-howl-85304.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterZ":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/en-GB/Abbi/letterZ.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#228c68",
                "Upper": "Z",
                "images":
                    [
                        {
                            "elementId": "",
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "213%",
                            "type": "Zero",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/numbers/Numbers_001_0.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "elementId": "",
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-91",
                            "centerBackgroundPositionX": "-91",
                            "backgroundPositionY": "-199",
                            "centerBackgroundPositionY": "-199",
                            "backgroundSize": "1300%",
                            "type": "Zebra",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/en-GB/Abbi/animals/Animals_019_Zebra.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            }
    }
export  default enGB;